import { RSAA } from "redux-api-middleware";
import config from "config";
import { TRANSCRIBER_LIST_ENDPOINT } from "lookup/TranscriberProgramConstants.jsx";

export const updateTranscriberProgramFaxList = (
  programCode,
  pageSize,
  page,
  sorted,
  filtered,
  resized,
  expanded
) => {
  const filteredWithProgramType = [
    { id: "faxProgramType", value: programCode, isdefault: true },
    ...filtered.filter((f) => f.id !== "faxProgramType"),
  ];

  return {
    [RSAA]: {
      endpoint: `${config.apiRoot}${TRANSCRIBER_LIST_ENDPOINT}`,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        pageSize,
        page,
        sorted,
        filtered: filteredWithProgramType,
      }),
      types: [
        {
          type: "UPDATE_TRANSCRIBER_PROGRAM_FAX_REQUEST",
          meta: { programCode },
          payload: {
            listState: { pageSize, page, sorted, filtered, resized, expanded },
          },
        },
        {
          type: "UPDATE_TRANSCRIBER_PROGRAM_FAX_SUCCESS",
          meta: { programCode },
        },
        {
          type: "UPDATE_TRANSCRIBER_PROGRAM_FAX_FAILURE",
          meta: { programCode },
        },
      ],
    },
  };
};

export const resetTranscriberProgramError = (programCode) => ({
  type: "RESET_ERROR_MESSAGE_TRANSCRIBER_PROGRAM_FAX",
  meta: { programCode },
});

export const updateTranscriberProgramIndexOnList = (programCode, index) => ({
  type: "UPDATE_TRANSCRIBER_PROGRAM_FAX_INDEX_ON_LIST",
  meta: { programCode },
  indexOnList: index,
});
